import axios from 'axios';

// var debug_model = window.conflux.chainId == '0x405' ? false : true
var debug_model = false
//  常规配置项
axios.defaults.baseURL = debug_model ? "http://36.112.119.146:6003/tspace/" :"https://tspace.io/tspace/"; //  请求服务器具体的地址
// axios.defaults.baseURL = 'http://36.112.119.146:6003/tspace/' ; //  请求服务器具体的地址
// axios.defaults.withCredentials  =true; //  在跨域中允许携带凭证
// axios.defaults.header['Content-Type'] = 'application/json';



// created:vue生命周期中的钩子函数，在这个时间点，data中的数据已经注入到响应式系统中
export async function setHeader(headerName, value) {
    if (!headerName) {
        console.error("setHeader", "参数不合法");
        return;
    }

    await axios.interceptors.request.use(
        (config) => {
            config.headers[headerName] = value;
            return config;
        },
        (err) => {
            return Promise.reject(err);
        }
    );
}

export function get(url, params){
    return axios.get(url,{       // 还可以直接把参数拼接在url后边
        params: params
    });
}


async function checkTokenValid(account) {
    //随便获取个 ID，验证 token 为失效
    axios.post('/system/getId', {}, {
        headers: {
            'Content-Type': 'application/json',
            'Access-Control-Allow-Origin': '*',
            'Access-Control-Allow-Headers': 'X-Requested-With,Content-Type',
            'Access-Control-Allow-Methods': 'PUT,POST,GET,DELETE,OPTIONS'
        }
    }).then(res => {

        if(401 == res.data.code) {
            axios.post('/system/getToken', {
                "walletAddress": account
            }, {
                headers: {
                    'Content-Type': 'application/json',
                    'Access-Control-Allow-Origin': '*',
                    'Access-Control-Allow-Headers': 'X-Requested-With,Content-Type',
                    'Access-Control-Allow-Methods': 'PUT,POST,GET,DELETE,OPTIONS'
                }
            }).then(res => {
                if(0 == res.data.code) {
                    localStorage.setItem('token', res.data.token)
                    setHeader("token", localStorage.getItem("token"));
                }
                
            });
        }
        
    });

}

export async function post(url, data) {
    checkHeaderConfig();
    //checkTokenValid(localStorage.getItem("account"))
	return axios.post(url, data, {
        headers: {
            'Content-Type': 'application/json',
            'Access-Control-Allow-Origin': '*',
            'Access-Control-Allow-Headers': 'X-Requested-With,Content-Type',
            'Access-Control-Allow-Methods': 'PUT,POST,GET,DELETE,OPTIONS'
        }
    });
}

export function upload(url, data) {
    checkHeaderConfig();
    // checkTokenValid(localStorage.getItem("account"))
	return axios.post(url, data, {
        headers: {
            'Content-Type': 'application/form-data',
            'Access-Control-Allow-Origin': '*',
            'Access-Control-Allow-Headers': 'X-Requested-With,Content-Type',
            'Access-Control-Allow-Methods': 'PUT,POST,GET,DELETE,OPTIONS'
        }
    });
}

async function checkHeaderConfig() {
    
    var accounts = await window.conflux.request({method: "cfx_accounts"});
    
    let sAddress = accounts[0]
    console.log("3334", sAddress)
    if( sAddress && sAddress != localStorage.getItem("account")) {
        localStorage.setItem("account", sAddress )
    }

    setHeader("walletAddress", localStorage.getItem("account"));

    localStorage.getItem("token") &&
    setHeader("token", localStorage.getItem("token"));
}
